import React from 'react';
import { Button } from '../components/Button';
import { LogoMark } from '../components/LogoMark';
import { LOGO_DARK } from '../data/site';
interface FinalCTAProps {
  onDownload: () => void;
}
export function FinalCTA({
  onDownload
}: FinalCTAProps) {
  return <section className="relative w-full overflow-hidden bg-charcoal py-20 lg:py-28" data-id="element-530">
      <div className="mgs-traces absolute inset-0 opacity-25" aria-hidden data-id="element-531" />
      <div className="relative mx-auto max-w-3xl px-5 text-center lg:px-8" data-id="element-532">
        <img src={LOGO_DARK} alt="Mine Geology Systems" className="mx-auto h-9 w-auto brightness-0 invert" data-id="element-533" />
        <h2 className="mt-8 text-3xl font-black leading-tight text-cream sm:text-4xl lg:text-5xl" data-id="element-534">
          Start building better mine geology systems.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-cream/80" data-id="element-535">
          Start with the free guide. Stay for the case studies. Built for
          geologists who care about doing the work properly.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-536">
          <Button variant="primary" onClick={onDownload} data-id="element-537">
            Download the Free MGS Toolkit
          </Button>
          <Button as="a" href="#framework" variant="ghost" className="text-cream hover:bg-cream/10" data-id="element-538">
            Explore the Framework
          </Button>
        </div>
        <div className="mt-8 flex items-center justify-center gap-2 text-xs text-cream/50" data-id="element-539">
          <LogoMark className="h-3.5 w-3.5" data-id="element-540" />
          Practical. Field-aware. Built for continuous improvement.
        </div>
      </div>
    </section>;
}